module.exports = __webpack_public_path__ + "static/media/spike.a93df914.png";